const formInputsData = {
	/*1: [
		{
			name: "u_looking_improve",
			label: "What would you love your new website to achieve for your business? Choose at least one.",
			subLabel: "Select all that apply",
			type: "checkbox",
			required: true,
			col: 12,
			options: [
                {
                    label: "Generate more qualified leads",
                    value: "Generate more qualified leads",
                },
                {
                    label: "Strengthen brand consistency",
                    value: "Strengthen brand consistency",
                },
                {
					label: "I need better user experience",
					value: "I need better user experience",
				},
				{
					label: "Create a unique, custom design",
					value: "Create a unique, custom design",
				},
				{
					label: "Add powerful, custom functionality",
					value: "Add powerful, custom functionality",
				},
				{
					label: "Optimize for search engines (SEO-ready)",
					value: "Optimize for search engines (SEO-ready)",
				},
				{
					label: "Improve mobile experience",
					value: "Improve mobile experience",
				},
				{
					label: "Boost speed and performance",
					value: "Boost speed and performance",
				},
				{
					label: "Make content updates quick and easy",
					value: "Make content updates quick and easy",
				},
			],
		},
	],*/
    1: [
        {
            name: "u_first_name",
            label: "Full Name",
            type: "text",
            required: true,
            col: 12,
            inputFullWidth: true,
        },
        {
            name: "u_email",
            label: "Email",
            type: "email",
            required: true,
            col: 6,
        },
        {
            name: "u_phone",
            label: "Phone",
            type: "tel",
            required: false,
            col: 6,
        },
        {
            name: "u_company",
            label: "Company Name",
            type: "text",
            required: false,
            col: 6,
        },
        {
            name: "u_company_position",
            label: "Position in Company",
            type: "text",
            required: false,
            col: 6,
        },
        {
            name: "u_website_url",
            label: "Your Website Address",
            type: "text",
            required: false,
            col: 12,
        },
    ],
};

const errorsData = {
	required: {
		default: "This field is required",
		u_first_name: "First name is required",
		u_last_name: "Last name is required",
		u_email: "Email is required",
		u_phone: "Phone is required",
		u_website: "Please answer the question",
		u_website_url: "Please enter your website URL",
		u_looking_improve: "Please select at least one option",
	},
};

const emailLabelsData = {
	u_first_name: "First Name",
	u_last_name: "Last Name",
	u_email: "Email",
	u_phone: "Phone",
	u_website: "Website",
	u_website_url: "Website URL",
	u_company: "Company",
	u_company_position: "Position in Company",
	u_looking_improve: "Looking to Improve",
	ref: "Ref",
};

const analyticsEventsData = {
	formView: "website_form",
	formSubmitted: "website_form_submitted",
	formStep: "website_form_step_",
};

export { formInputsData, errorsData, emailLabelsData, analyticsEventsData };
